import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import useLeaveTypePieData from './useLeaveTypePieData';
import ChartGlassPanel from '../../components/ChartGlassPanel';

const COLORS = ['#2563eb', '#f59e42', '#22c55e', '#e11d48'];

export default function LeaveTypePieChart() {
  const data = useLeaveTypePieData();
  return (
    <ChartGlassPanel>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              dataKey="value"
              nameKey="type"
              cx="50%"
              cy="50%"
              outerRadius={80}
              label
            >
              {data.map((entry, idx) => (
                <Cell key={`cell-${idx}`} fill={COLORS[idx % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </ChartGlassPanel>
  );
}
